/* eslint-disable react/style-prop-object */
/* eslint-disable max-len */
import React, { FC, useCallback, useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Box, Button, FormControl, Snackbar, TextField, Typography } from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";
import { Controller, FormProvider, useForm } from "react-hook-form";
import axios from "axios";
import userService from "services/userService";
import { useNavigate } from "react-router-dom";
import { SET_TOKEN, SET_USER } from "slices/global.slice";
import { useDispatch } from "react-redux";
import NotificationService from "services/notificationService";
import classes from "../../style";

const ConnexionMail: FC<{ search: String }> = (props) => {
  const [authSuccessful, setAuthSuccessful] = useState<boolean | undefined>(undefined);
  const navigate = useNavigate();
  const onCaptchaChange = useCallback((captchaValue: any) => {
    // eslint-disable-next-line no-console
  }, []);
  const dispatch = useDispatch();
  const [snackMessage, setSnack] = useState<string | undefined>(undefined);

  const reactHookForm = useForm({
    mode: "all",
    reValidateMode: "onChange",
  });

  const handleAuth = async (data) => {
    try {
      const loginResponse = await userService.signIn(data.mail, data.password);
      localStorage.setItem("token", loginResponse.token);
      dispatch(SET_TOKEN(loginResponse.token));
      dispatch(SET_USER(loginResponse.user));
      axios.defaults.headers.common.Authorization = `Bearer ${loginResponse.token}`;
      NotificationService().connect(loginResponse.token);
      setAuthSuccessful(true); // added to set the state
    } catch (error: any) {
      localStorage.removeItem("token");
      dispatch(SET_TOKEN(null));
      setAuthSuccessful(false); // added to set the state

      if (error.response.data == 'Invalid password.' || error.response.data == 'User not found.') {
        setSnack("L'adresse email et le mot de passe ne correspondent pas.");
      } else {
        setSnack("Une erreur est survenue. Veuillez contacter l'administrateur.");
      }
    }
  };

  useEffect(() => {
    if (authSuccessful) {
      if (props.search != '') {
        navigate("/liste-profils" + props.search);
      }
      else {
        navigate('/passeport');
      }
    }
  }, [authSuccessful, navigate]);

  const {
    control,
    handleSubmit,
    formState: { errors },
    trigger,
    setValue,
  } = reactHookForm;

  return (<>
    <FormProvider {...reactHookForm}>
      <form onSubmit={handleSubmit(handleAuth)}>
        <Card sx={classes.card} style={{ width: '100%' }}>
          <CardContent>
            <Box sx={{ my: 2 }}>
              <Typography sx={classes.label}>Adresse e-mail</Typography>
              <FormControl fullWidth>
                <Controller
                  name="mail"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: "Champ obligatoire",
                    pattern: {
                      value:
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                      message: "Adresse e-mail invalide",
                    },
                  }}
                  render={({ field: { onChange, ref, ...field } }) => (
                    <TextField
                      {...field}
                      inputRef={ref}
                      onChange={({ target: { value: fieldValue, name } }) => {
                        onChange(fieldValue);
                        if (setValue) setValue(name, fieldValue);
                      }}
                      error={!!errors.mail}
                      helperText={errors.mail?.message as string}
                      placeholder="john.doe@gmail.com"
                      hiddenLabel
                      fullWidth
                      id={field.name}
                      defaultValue="john.doe@gmail.com"
                      size="small"
                    />
                  )}
                />
              </FormControl>
            </Box>
            <Box sx={{ my: 2 }}>
              <Typography sx={classes.label}>Mot de passe</Typography>
              <FormControl fullWidth>
                <Controller
                  name="password"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: "Champ obligatoire",
                    pattern: {
                      value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d|(?=.*\W)).{8,64}$/,
                      message: "Mot de passe invalide",
                    },
                  }}
                  render={({ field: { onChange, ref, ...field } }) => (
                    <TextField
                      {...field}
                      inputRef={ref}
                      onChange={({ target: { value: fieldValue, name } }) => {
                        onChange(fieldValue);
                        if (setValue) setValue(name, fieldValue);
                      }}
                      error={!!errors.password}
                      helperText={errors.password?.message as string}
                      placeholder="********"
                      hiddenLabel
                      fullWidth
                      type="password"
                      id={field.name}
                      defaultValue="********"
                      size="small"
                    />
                  )}
                />
              </FormControl>
            </Box>
            <Box sx={{ my: 2 }}>
              <Button variant="contained" type="submit" sx={{ mr: 2 }}>
                Se connecter
              </Button>
              <Button sx={classes.linkBtnThin} href="/mot-de-passer-oublie">
                Mot de passe oublié ?
              </Button>
            </Box>
            <Box sx={{ my: 2, justifyContent: "center" }}>
              <ReCAPTCHA
                sitekey="Your client site key"
                onChange={onCaptchaChange}
              />
            </Box>
          </CardContent>
        </Card>
      </form>
    </FormProvider>
    <Snackbar
      open={snackMessage !== undefined}
      autoHideDuration={3000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      onClose={() => setSnack(undefined)}
      message={snackMessage}
    />
  </>
  );
};

export default ConnexionMail;
